export * from './IPhone.interface';
